<template>
  <div class="chapter-section-trial-exam">
    <TrialExam
      :name="trialExamData.name"
      :description="trialExamData.description"
      :question-count="trialExamData.questionCount"
      :test-template-id="trialExamData.chapterTestTemplateId"
      :time-limit="trialExamData.timeLimit"
      :grading-available="trialExamData.gradingAvailable"
      :extra-post-data="{ chapter_test: this.chapterTestId }"
    />
  </div>
</template>

<script>
import TrialExam from '@/components/training/TrialExam'

import { BookStoreNamespacedTypes } from '@/store/books'

export default {
  name: 'ChapterSectionTrialExam',
  components: { TrialExam },
  props: {
    chapterId: {
      type: Number,
      required: true,
    },
    chapterTestId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    trialExamData() {
      return (
        this.$store.getters[BookStoreNamespacedTypes.getters.GET_CHAPTER](
          this.chapterId
        )?.trialExams.find(
          trialExam => trialExam.chapterTestId === this.chapterTestId
        ) || {}
      )
    },
  },
}
</script>
